var _path, _path2, _g, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7 15.6451H9.72879C9.38795 15.6451 9.11133 15.3684 9.11133 15.0276C9.11133 14.6868 9.38795 14.4102 9.72879 14.4102H15.7C16.0408 14.4102 16.3175 14.6868 16.3175 15.0276C16.3175 15.3684 16.0408 15.6451 15.7 15.6451Z",
    fill: "#5D6373"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_507_4340",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.263672 0.0527344H14.408V15.6452H0.263672V0.0527344Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_507_4340)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41049 1.71299L1.65935 11.4071C1.51857 11.5832 1.4667 11.8105 1.51857 12.0286L2.07922 14.4038L4.58116 14.3725C4.81908 14.37 5.0389 14.2638 5.18462 14.0827C7.8331 10.769 12.8822 4.4512 13.0255 4.26597C13.1605 4.04698 13.2132 3.73742 13.1424 3.4394C13.07 3.13396 12.8798 2.87463 12.6056 2.70915C12.5472 2.66881 11.16 1.59197 11.1171 1.55821C10.5952 1.13999 9.83366 1.21244 9.41049 1.71299ZM1.59184 15.6453C1.30616 15.6453 1.05754 15.4493 0.99085 15.1703L0.316587 12.3127C0.177454 11.7207 0.315764 11.1099 0.695294 10.6357L8.45055 0.935815C8.45385 0.932522 8.45632 0.928406 8.45961 0.925113C9.31005 -0.0916331 10.8479 -0.241469 11.8853 0.590863C11.9264 0.62297 13.3038 1.69323 13.3038 1.69323C13.8043 1.99125 14.1954 2.52391 14.3436 3.15454C14.4909 3.77859 14.3839 4.42239 14.0406 4.96657C14.0151 5.00691 13.9928 5.04149 6.14867 14.8549C5.77079 15.3259 5.20438 15.6 4.59598 15.6074L1.60007 15.6453H1.59184Z",
    fill: "#5D6373"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9731 7.20176C11.8414 7.20176 11.7096 7.15977 11.5969 7.07415L7.10835 3.62627C6.83832 3.4188 6.78728 3.03186 6.99474 2.76018C7.20303 2.49015 7.58997 2.43993 7.86083 2.64739L12.3502 6.09445C12.6202 6.30191 12.6712 6.68968 12.4629 6.96054C12.3419 7.1186 12.1583 7.20176 11.9731 7.20176Z",
    fill: "#5D6373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.ca9f2360b8938c0d43e1777df8763d3b.svg";
export { ForwardRef as ReactComponent };